import { v4 as uuidv4 } from 'uuid'

import type { DatasetInfo, Filter } from '@wix/wix-data-client-types'
import {
  CATEGORY_FIELD_PLUGIN_ID,
  FieldType,
  type Schema,
} from '@wix/wix-data-schema-types'

const buildFilter = (fieldKey: string, routerDataset: DatasetInfo): Filter => ({
  field: fieldKey,
  condition: 'includesAny',
  dataset: routerDataset.controllerRef,
  datasetField: '_id',
  filterId: `filter-${uuidv4()}`,
  value: null,
})

export const getDefaultFilters = ({
  collection,
  routerDataset,
  multiRefFallbackEnabled = false,
}: {
  collection?: Schema
  routerDataset?: DatasetInfo
  multiRefFallbackEnabled?: boolean
}): Filter[] => {
  if (!collection || !routerDataset) {
    return []
  }

  const dynamicPageCollectionId = routerDataset.config.collectionId

  const isMultiRefToDynamicPageCollection = (field: Schema['fields'][string]) =>
    field.type === FieldType.multiReference &&
    field.referencedCollection === dynamicPageCollectionId

  const fieldEntries = Object.entries(collection.fields)

  const categoryFieldEntry = fieldEntries.find(
    ([, field]) =>
      isMultiRefToDynamicPageCollection(field) &&
      !!field.plugins?.[CATEGORY_FIELD_PLUGIN_ID],
  )

  const matchingEntry =
    categoryFieldEntry ??
    (multiRefFallbackEnabled
      ? fieldEntries.find(([, field]) =>
          isMultiRefToDynamicPageCollection(field),
        )
      : undefined)

  if (!matchingEntry) {
    return []
  }

  const [fieldKey] = matchingEntry
  return [buildFilter(fieldKey, routerDataset)]
}
